var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.048,
    height: 122.049,
    viewBox: "0 0 122.048 122.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(-922.918 -459.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    transform: "translate(932.918 469.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M51.024,0A51.024,51.024,0,1,1,0,51.024,51.024,51.024,0,0,1,51.024,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#a5a5a5",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M1313.618,352.651a51.024,51.024,0,0,1,0,102.049",
    transform: "translate(-1262.594 -352.651)",
    fill: "none",
    stroke: "#ffd164",
    strokeMiterlimit: 10,
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M1365.678,401.17a51.017,51.017,0,0,1-72.159,0",
    transform: "translate(-1278.575 -314.069)",
    fill: "none",
    stroke: "#ff6363",
    strokeMiterlimit: 10,
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    d: "M1313.618,352.651a51.025,51.025,0,0,1,51.024,51.024",
    transform: "translate(-1262.594 -352.651)",
    fill: "none",
    stroke: "#3db250",
    strokeMiterlimit: 10,
    strokeWidth: 20
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartImage);
export default __webpack_public_path__ + "static/media/ChartImage.fdb268a3fee7063e682737274524691b.svg";
export { ForwardRef as ReactComponent };